<template>
  <layout-editor-page
    :title="formTitle"
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="hasCreateNew"
    :isCancel="!hasCreateNew"
    @command="setCommand"
  >
    <form-contacts
      :disabled="disabled"
      :data="data"
      :model="formModel"
      @change="handleFormData"
      @updateModelItem="handlerUpdateModelItem"
      ref="Form"/>
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        :isCreate="!hasCreateNew && !disabled"
        :isSave="hasCreateNew && !disabled"
        :isClipboard="hasCreateNew"
        :isDelete="hasCreateNew && !disabled"
        @command="setCommand"
      />
    </template>
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'

export default {
  name: 'EditorContacts',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'form-contacts': () => import(/* webpackChunkName: 'Contacts' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'Contacts/Patch/${data.id}'
    }
  },
  computed: {
    formTitle () {
      return this.formData.name || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        title: '',
        name: '',
        email: '',
        phone: '',
        phone2: '',
        fax: '',
        mobile: '',
        remark: '',
        divisionID: null,
        companyID: null
      }
    }
  }
}
</script>
